module.exports = "/assets/hummingbird.png";